import React, { useEffect, useState } from "react";
import BannerSectionStyle5 from "../components/Section/BannerSection/BannerSectionStyle5";
import Section from "../components/Section";
import DepartmentSectionStyle3 from "../components/Section/DepartmentSection/DepartmentSectionStyle3";
import BannerSectionStyle6 from "../components/Section/BannerSection/BannerSectionStyle6";
import { pageTitle } from "../helpers/PageTitle";
import axiosInstance from "../utils/axiosInstance";
import { fetchDoctorCategories } from "../constants/ApiConstants";

export default function Departments() {
  pageTitle("Departments");

  const [departments, setDepartments] = useState([]);
  useEffect(() => {
    axiosInstance
      .post(fetchDoctorCategories)
      .then((res) => {
        setDepartments(res.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/departments/banner_bg.svg"
        imgUrl="https://images.unsplash.com/photo-1513224502586-d1e602410265?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGhvc3BpdGFsfGVufDB8fDB8fHww"
        title="Get to Know <br>VDOC Departments"
        subTitle="At VDOC, we offer a wide range of medical and healthcare services that are designed to meet your individual needs and help you achieve optimal health."
      />
      <Section bottomMd={140} bottomLg={100} bottomXl={60}>
        <DepartmentSectionStyle3 data={departments} />
      </Section>
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle6 imgUrl="https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fGhvc3BpdGFsfGVufDB8fDB8fHww" title="Don’t Let Your Health Take a Backseat!" subTitle="Schedule an appointment with one of our <br />experienced medical professionals today!" />
      </Section>
    </>
  );
}
